export default "__VITE_ASSET__CIEp$IkA__"